<div class="thumb-list-overlay">
  <div class="thumb-list-overlay-bg"></div>
  <div class="thumb-drag-el-wrapper">
    <div class="thumb-drag-el-placeholder">
      <ng-content select="[cdkDragHandle]"></ng-content>
    </div>
    <span class="thumb-drag-el"></span>
  </div>
  <div class="thumb-list-container" [style.max-height.px]="maxHeight" #scrollContainer (scroll)="checkMobileHeight()">
    <div class="thumb-item-wrapper">
      <div class="thumb-item" [class.active]="player.position === 0" (click)="setPosition(0)">
        <canvas #thumbItem></canvas>
        <div class="thumb-item-title">
          {{ player.playerData.cameras[0].title }}
        </div>
      </div>
    </div>
    <div class="thumb-item-wrapper">
      <div class="thumb-item" [class.active]="player.position === 1" (click)="setPosition(1)">
        <canvas #thumbItem></canvas>
        <div class="thumb-item-title">
          {{ player.playerData.cameras[1].title }}
        </div>
      </div>
    </div>
    <div class="thumb-item-wrapper">
      <div class="thumb-item" [class.active]="player.position === 2" (click)="setPosition(2)">
        <canvas #thumbItem></canvas>
        <div class="thumb-item-title">
          {{ player.playerData.cameras[2].title }}
        </div>
      </div>
    </div>
    <div class="thumb-item-wrapper">
      <div class="thumb-item" [class.active]="player.position === 3" (click)="setPosition(3)">
        <canvas #thumbItem></canvas>
        <div class="thumb-item-title">
          {{ player.playerData.cameras[3].title }}
        </div>
      </div>
    </div>

    <div class="thumb-button-wrapper">
      <div class="btn btn-quaternary" (click)="closeThumb.emit()">
        <span class="mb-icon mb-icon-close"></span>
        <span>{{ 'CLOSE' | translate }}</span>
      </div>
    </div>
  </div>

  <div class="thumb-scroll-indicator-wrapper" [class.hide]="!showScrollIndicator">
    <div class="btn btn-round" (click)="scrollDown()">
      <span class="mb-icon mb-icon-down"></span>
    </div>
  </div>
</div>
